/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.temp.requestPhoneVerification'

export { $nsid }

/** Request a verification code to be sent to the supplied phone number */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({ phoneNumber: l.string() }),
  l.payload(),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output
